module.exports = "<!-- <app-sns-notifications></app-sns-notifications> -->\n<router-outlet></router-outlet>\n\n\n"